import React from 'react'
import { Row, Col } from 'react-bootstrap'
import FilterLabel from './FilterLabel'

function SelectField({
  params,
  setParams,
  options,
  accessorKey,
  title,
  showTitle = false,
  placeholder = '',
  hideClearButton = false,
  disabled = false
}) {
  const isActive = params[accessorKey] && params[accessorKey].length > 0
  const clearFilter = () => {
    setParams({ ...params, [accessorKey]: '' })
  }

  return (
    <Row className="mt-3 mb-3 d-flex">
      <Col sm={3}>
        <FilterLabel
          columnName={title}
          onClearClick={hideClearButton ? null : clearFilter}
          isActive={hideClearButton ? false : isActive}
        />
      </Col>
      <Col sm={9}>
        <select
          className="form-select"
          name={title}
          value={params[accessorKey]}
          onChange={(e) =>
            setParams({ ...params, [accessorKey]: e.target.value })
          }
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </Col>
    </Row>
  )
}

export default SelectField
